import { createEntityAdapter } from '@reduxjs/toolkit'

import type { Creator } from '@/model/creator'

export const creatorAdapter = createEntityAdapter<Creator>()
export const creatorSelector = creatorAdapter.getSelectors()
